export function getFromId(name, id) {
    let { getFromIdRequest, getFromIdError, getFromIdResult } = this.props

    this.doAction(
        this.HADES + 'get_from_id',
        this.createBundle('get_from_id', { name, id }, this.POST, getFromIdRequest, getFromIdResult, getFromIdError)
    )
}
